/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Status_ResetInputs */

const fr_status_reset = /** @type {(inputs: Status_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuration réinitialisée`)
};

const en_status_reset = /** @type {(inputs: Status_ResetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuration reset`)
};

/**
* | output |
* | --- |
* | "Configuration reset" |
*
* @param {Status_ResetInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const status_reset = /** @type {((inputs?: Status_ResetInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Status_ResetInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_status_reset(inputs)
	return en_status_reset(inputs)
});